import EditFieldContent from './FieldContent/EditFieldContent';
import EnhancedPreviewFieldContent from './FieldContent/EnhancedPreviewFieldContent';
import PreviewFieldContent from './FieldContent/PreviewFieldContent';

const FieldRenderer = ({ field, onEdit, onDelete, onMoveUp, onMoveDown, canMoveUp, canMoveDown, isMoving, mode = 'edit', area }) => {
  // Special handling for avatar area to show icon
  const renderAvatarContent = () => {
    if (area === 'avatar') {
      if (mode === 'edit') {
        return (
          <div className="hvnly--builder---api_property__builder___avatar_with_icon">
            <div className="hvnly--builder---api_property__builder___single_page_card_avatar">
              <i className="fas fa-user"></i>
            </div>
            <EditFieldContent 
              field={field} 
              onEdit={onEdit} 
              onDelete={onDelete}
              onMoveUp={onMoveUp}
              onMoveDown={onMoveDown}
              canMoveUp={canMoveUp}
              canMoveDown={canMoveDown}
              isMoving={isMoving}
            />
          </div>
        );
      } else if (mode === 'enhanced-preview') {
        return (
          <div className="hvnly--builder---api_property__builder___avatar_with_icon">
            <div className="hvnly--builder---api_property__builder___enhanced_preview_card_avatar">
              <i className="fas fa-user"></i>
            </div>
          </div>
        );
      }
    }
    
    // Default rendering for other areas
    const renderContent = () => {
      switch (mode) {
        case 'preview':
          return <PreviewFieldContent field={field} area={area} />;
        case 'enhanced-preview':
          return <EnhancedPreviewFieldContent field={field} area={area} />;
        default:
          return (
            <EditFieldContent 
              field={field} 
              onEdit={onEdit} 
              onDelete={onDelete}
              onMoveUp={onMoveUp}
              onMoveDown={onMoveDown}
              canMoveUp={canMoveUp}
              canMoveDown={canMoveDown}
              isMoving={isMoving}
            />
          );
      }
    };

    return renderContent();
  };

  return <div className="field-renderer">{renderAvatarContent()}</div>;
};

export default FieldRenderer;